/* tslint:disable:max-line-length */
import gql from 'graphql-tag';

export const DeleteDevices = gql`
  mutation DeleteDevices($ids: [ID!]!) {
    deleteDevices(ids: $ids)
  }
`;
